<template>
  <p class="c-meta-field">
    <icon width="18" height="18" :name="icon" class="icon" v-if="showIcon" />
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "clock",
    },
  },
};
</script>

<style scoped lang="scss">
.c-meta-field {
  display: inline-flex;
  align-items: center;
  line-height: 0.875rem;
  margin: 0;
  padding: 0;
  font-weight: normal;
  font-size: 14px;
  color: #64727e;
}
.icon {
  margin-right: 5px;
  fill: #64727e;
}
</style>
